import '../assets/XClose.css';
import { h, defineComponent, useCssVars, computed, openBlock, createElementBlock, unref, withModifiers, createVNode } from 'vue';
import { d as debounce } from './debounce.CJgNZ1TL.js';
import { A as AgentActionKind } from './maps.nxkzRTum.js';
import { u as useI18n } from './widgets-core.es.C7uAbUpp.js';
import { o as useStore, t as tinycolor } from './useStore.DAPvMbcE.js';

const icon = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 4.47a.75.75 0 011.06 0L10 8.94l4.47-4.47a.75.75 0 111.06 1.06L11.06 10l4.47 4.47a.75.75 0 11-1.06 1.06L10 11.06l-4.47 4.47a.75.75 0 01-1.06-1.06L8.94 10 4.47 5.53a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const _hoisted_1 = ["aria-label"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "XClose",
  props: {
    triggerDismiss: { type: Boolean, default: true },
    onlyCloseModal: { type: Boolean, default: false }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "2787ccfc": hoveredBackgroundColor.value
    }));
    const store = useStore();
    const { t } = useI18n();
    const props = __props;
    const hoveredBackgroundColor = computed(() => {
      const isToolBackgroundDark = tinycolor(store?.styles.colors.background?.base ?? "white").isDark();
      return isToolBackgroundDark ? "rgba(255, 255, 255, 0.5)" : "rgba(97, 97, 97, 0.4)";
    });
    const onClick = debounce(() => {
      if (props.onlyCloseModal) {
        return;
      }
      if (props.triggerDismiss === true) {
        store.handlers?.callHandler(AgentActionKind.Dismiss);
      }
    }, 200, { leading: true, trailing: false });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        type: "button",
        class: "thn--tool-xclose",
        "aria-label": unref(t)("Close dialog"),
        onMousedown: _cache[0] || (_cache[0] = withModifiers(
          //@ts-ignore
          (...args) => unref(onClick) && unref(onClick)(...args),
          ["left"]
        )),
        onClick: _cache[1] || (_cache[1] = //@ts-ignore
        (...args) => unref(onClick) && unref(onClick)(...args))
      }, [
        createVNode(unref(icon), {
          class: "thn--tool-xclose__svg",
          "aria-hidden": "true"
        })
      ], 40, _hoisted_1);
    };
  }
});

export { _sfc_main as _, icon as i };
//# sourceMappingURL=XClose.vue_vue_type_style_index_0_lang.BnBsLGqK.js.map
